<template>
  <div class="header-wrapper">
    <header class="header">
      <div class="logo">
        <router-link :to="{ name: 'HomeView' }">
          <img src="@/assets/logo.png" alt="とんじき">
        </router-link>
      </div>
      <nav class="global-nav" aria-label="メインメニュー">
        <router-link :to="{ name: 'MenuList' }">お品書き</router-link>
        <router-link :to="{ name: 'HomeView', hash: '#about' }">こだわり</router-link>
        <router-link :to="{ name: 'HomeView', hash: '#access' }">店舗について</router-link>
        <router-link :to="{ name: 'ContactForm' }">お問い合わせ</router-link>
      </nav>
      <router-link class="header-order" :to="{ name: 'MenuList' }">ご注文はこちら</router-link>
    </header>
    <button class="navbar-responsive" type="button" aria-label="メニューを開く" @click="onClickMenu">
      <img src="@/assets/images/hamburger-btn.png" alt="とんじき_メニュー">
    </button>
  </div>
</template>

<script>
export default {
  name: "ShopNavbar",
  // props: { isSignedIn: {} },
  emits: ["openmenu"],
  setup(_, {emit}) {
    const onClickMenu = () => {
      // サイドメニューの開閉イベントを発行
      emit("openmenu");
    };
    return { onClickMenu };
  },
};
</script>


<style scoped>
.header-wrapper {
  height: 88px;
}

.header {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 88px;
  padding: 0 0 0 5vw;
  display: flex;
  align-items: center;
  gap: 42px;
  background: rgba(28, 26, 23, .97);
  border-bottom: 1px solid rgba(255,255,255,.12);
  z-index: 101;
}

.logo {
  width: 122px;
  flex: 0 0 auto;
}
.logo img { display:block; width:100%; height:auto; }
.global-nav { margin-left:auto; display:flex; align-items:center; gap:36px; }
.global-nav a { color:#f7f3eb; font-family:"Noto Serif JP", serif; letter-spacing:.12em; font-size:14px; }
.global-nav a:hover { color:#d8b47a; }
.header-order { align-self:stretch; display:flex; align-items:center; padding:0 34px; background:#a94336; color:white; letter-spacing:.14em; }

.navbar-responsive{
  display: none;
}
@media (max-width: 1320px) {
  .header { padding-left:32px; gap:24px; }
  .global-nav { gap:22px; }
  .global-nav a { font-size:13px; letter-spacing:.06em; }
  .header-order { padding:0 24px; font-size:13px; white-space:nowrap; }
}
@media (max-width: 820px) {
  .header-wrapper,.header { height:68px; }
  .header { padding-left:20px; }
  .logo { width:94px; }
  .global-nav { display:none; }
  .header-order { margin-left:auto; padding:0 18px; font-size:12px; }
  .navbar-responsive { display:flex; align-items:center; justify-content:center; position:fixed; right:146px; top:12px; width:44px; height:44px; padding:10px; border:0; background:transparent; z-index:110; filter:invert(1); cursor:pointer; }
  .navbar-responsive img { display:block; width:100%; height:auto; }
}
@media (max-width: 420px) {
  .header { padding-left:16px; }
  .logo { width:82px; }
  .header-order { padding:0 12px; font-size:11px; letter-spacing:.06em; }
  .navbar-responsive { right:122px; }
}
</style>
